import React from "react";
import Navbar from "./Navbar";
import { Footer } from "./Contact";
import ChatWidget from "./ChatWidget";
import SelectionTranslate from "./SelectionTranslate";
import { useLenis } from "../lib/useLenis";
import { bgGlobe } from "../lib/images";

export default function PageShell({ children }) {
  useLenis();
  return (
    <div className="relative grain bg-ink text-white min-h-screen antialiased">
      <div className="fixed inset-0 z-0 pointer-events-none" aria-hidden="true">
        <img src={bgGlobe} alt="" className="w-full h-full object-cover opacity-[0.12]" />
        <div className="absolute inset-0 bg-ink/40" />
      </div>
      <div className="relative z-10">
        <Navbar />
        <main>{children}</main>
        <Footer />
        <ChatWidget />
        <SelectionTranslate />
      </div>
    </div>
  );
}
